<template>
    <v-row align="center">
        <v-col :cols="isCustom ? 5 : 6" :sm="isCustom ? 5 : 6">
            <v-select
                    :items="rangeFirstMenuItems"
                    variant="outlined"
                    v-model="firstMenuValue"
                    @change="onFirstMenuValueChange"
                    class="cst-select"
                    bg-color="success"
            ></v-select>
        </v-col>
        <v-col cols="2" sm="2" class="mt-5" v-if="isCustom">
            <v-text-field
                    type="number"
                    v-model="lastValue"
                    bg-color="white"
                    label="Last"
                    outlined
                    dense
                    @input="value => lastValue = Number(value)"
            ></v-text-field>
        </v-col>
        <v-col :cols="isCustom ? 5 : 6" :sm="isCustom ? 5 : 6">
            <div v-if="firstMenuValue !== rangeFirstMenuItems[2]">
                <div v-if="firstMenuValue !== rangeFirstMenuItems[0]">
                    <v-select
                            :items="rangeSecondMenuItems"
                            variant="outlined"
                            v-model="secondMenuValue"
                            class="cst-select"
                    ></v-select>
                </div>
            </div>
            <div v-else>
                <v-menu
                        ref="dateMenuOne"
                        v-model="dateMenuOne"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="320px"
                        min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="selectedDateOne"
                                persistent-hint
                                readonly
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                hide-details
                                single-line
                                class="pt-0 mt-0 picker-text"
                                v-on="on"
                                :style="{ background: 'white' }"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                            no-title
                            :close-on-content-click="false"
                            v-model="selectedDateOne"
                            @input="dateMenuOne = false"
                            show-current
                    >
                        <v-spacer></v-spacer>
                    </v-date-picker>
                </v-menu>
                <v-menu
                        ref="dateMenuTwo"
                        v-model="dateMenuTwo"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        max-width="320px"
                        min-width="auto"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                                v-model="selectedDateTwo"
                                persistent-hint
                                readonly
                                prepend-inner-icon="mdi-calendar"
                                v-bind="attrs"
                                hide-details
                                single-line
                                class="pt-0 mt-10 picker-text"
                                v-on="on"
                                :style="{ background: 'white' }"
                        ></v-text-field>
                    </template>
                    <v-date-picker
                            no-title
                            :close-on-content-click="false"
                            v-model="selectedDateTwo"
                            @input="dateMenuTwo = false"
                            show-current
                    >
                        <v-spacer></v-spacer>
                    </v-date-picker>
                </v-menu>
            </div>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        props: {
            rangeFirstMenuItems: { type: Array, required: true },
            currentItems: { type: Array, required: true },
            previousItems: { type: Array, required: true },
            lastItems: { type: Array, required: true },
            initialFirstMenuValue: { type: String, default: 'All Time' },
            initialSecondMenuValue: { type: String, default: null },
            initialLastValue: { type: Number, default: 0 },
            initialSelectedDateOne: { type: String, default: null },
            initialSelectedDateTwo: { type: String, default: null },
        },
        data() {
            return {
                firstMenuValue: this.initialFirstMenuValue,
                secondMenuValue: this.initialSecondMenuValue,
                lastValue: this.initialLastValue,
                selectedDateOne: this.initialSelectedDateOne,
                selectedDateTwo: this.initialSelectedDateTwo,
                dateMenuOne: false,
                dateMenuTwo: false,
                rangeSecondMenuItems: [],
            };
        },
        computed: {
            isCustom() {
                return this.firstMenuValue === this.rangeFirstMenuItems[4];
            },
        },
        watch: {
            firstMenuValue() {
                this.updateSecondMenuItems();
                this.emitRange();
            },
            secondMenuValue() {
                this.emitRange();
            },
            lastValue() {
                this.emitRange();
            },
            selectedDateOne() {
                this.emitRange();
            },
            selectedDateTwo() {
                this.emitRange();
            },
        },
        mounted() {
            this.updateSecondMenuItems();
        },
        methods: {
            onFirstMenuValueChange() {
                this.updateSecondMenuItems();
            },
            updateSecondMenuItems() {
                switch (this.firstMenuValue) {
                    case this.rangeFirstMenuItems[1]:
                        this.rangeSecondMenuItems = [...this.currentItems];
                        break;
                    case this.rangeFirstMenuItems[3]:
                        this.rangeSecondMenuItems = [...this.previousItems];
                        break;
                    case this.rangeFirstMenuItems[4]:
                        this.rangeSecondMenuItems = [...this.lastItems];
                        break;
                    default:
                        this.rangeSecondMenuItems = [];
                }
            },
            emitRange() {
                this.$emit('update', {
                    firstMenuValue: this.firstMenuValue,
                    secondMenuValue: this.secondMenuValue,
                    lastValue: this.lastValue,
                    selectedDateOne: this.selectedDateOne,
                    selectedDateTwo: this.selectedDateTwo,
                });
            },
        },
    };
</script>
